import axios from 'axios';

// Base URL for backend API. In production set REACT_APP_API_URL in your env (e.g. Vercel dashboard).
// During local development this falls back to localhost; in a deployed SPA it calls the same origin.
const API_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000/api'
    : `${window.location.origin.replace(/\/$/, '')}/api`);

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Department API calls
export const getDepartments = () => api.get('/departments');
export const getDepartment = (id) => api.get(`/departments/${id}`);
export const createDepartment = (data) => api.post('/departments', data);
export const updateDepartment = (id, data) => api.put(`/departments/${id}`, data);
export const deleteDepartment = (id) => api.delete(`/departments/${id}`);

// Semester API calls
export const getSemesters = () => api.get('/semesters');
export const getSemester = (id) => api.get(`/semesters/${id}`);
export const createSemester = (data) => api.post('/semesters', data);
export const updateSemester = (id, data) => api.put(`/semesters/${id}`, data);
export const deleteSemester = (id) => api.delete(`/semesters/${id}`);

// Room API calls
export const getRooms = () => api.get('/rooms');
export const getRoom = (id) => api.get(`/rooms/${id}`);
export const createRoom = (data) => api.post('/rooms', data);
export const updateRoom = (id, data) => api.put(`/rooms/${id}`, data);
export const deleteRoom = (id) => api.delete(`/rooms/${id}`);

// Teacher API calls
export const getTeachers = () => api.get('/teachers');
export const getTeacher = (id) => api.get(`/teachers/${id}`);
export const createTeacher = (data) => api.post('/teachers', data);
export const updateTeacher = (id, data) => api.put(`/teachers/${id}`, data);
export const deleteTeacher = (id) => api.delete(`/teachers/${id}`);

// Subject API calls
export const getSubjects = () => api.get('/subjects');
export const getSubject = (id) => api.get(`/subjects/${id}`);
export const createSubject = (data) => api.post('/subjects', data);
export const updateSubject = (id, data) => api.put(`/subjects/${id}`, data);
export const deleteSubject = (id) => api.delete(`/subjects/${id}`);

// Teacher-Subject API calls
export const getTeacherSubjects = (params = {}) => {
  return api.get('/teacher-subjects', { params });
};
export const getTeacherSubject = (id) => api.get(`/teacher-subjects/${id}`);
export const createTeacherSubject = (data) => api.post('/teacher-subjects', data);
export const updateTeacherSubject = (id, data) => api.put(`/teacher-subjects/${id}`, data);
export const deleteTeacherSubject = (id) => api.delete(`/teacher-subjects/${id}`);

// Timetable API calls
export const getTimetable = (departmentId, semesterId) => {
  return api.get(`/timetable?department_id=${departmentId}&semester_id=${semesterId}`);
};

export const getFormattedTimetable = (departmentId, semesterId) => {
  const cacheBuster = new Date().getTime();
  return api.get(`/timetable/formatted?department_id=${departmentId}&semester_id=${semesterId}&_=${cacheBuster}`);
};
export const createTimetableSlot = (data) => api.post('/timetable/slot', data);
export const updateTimetableSlot = (id, data) => api.put(`/timetable/slot/${id}`, data);
export const deleteTimetableSlot = (id) => api.delete(`/timetable/slot/${id}`);
export const generateTimetable = (data) => api.post('/timetable/generate', data);
export const deleteSectionTimetable = (data) => api.delete('/timetable/delete-section-timetable', { data });

// Teacher Timetable API calls
export const getTeacherTimetables = () => api.get('/teacher-timetable');
export const getTeacherTimetable = (teacherId) => api.get(`/teacher-timetable/${teacherId}`);

export default api;
